'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { ColumnFiltersState } from '@tanstack/table-core';
import type { PropsWithChildren, SetStateAction } from 'react';
import { Search } from '@morpho-org/ui-v6/client';
import type { DashboardActivityFilters as DashboardActivityFiltersType } from '@/helpers/filter/table';
import AdvancedNetworkFilter from '@/components/common/TableAdvancedFilters/AdvancedNetworkFilter';
import { useIsMobile } from '@/hooks/useBreakpoints';
import { useTableFiltersHandler } from '../../hooks/useTableFiltersHandler';
import { LIQUIDATION_COLUMN_IDS } from '../config';
interface FilterProps {
  filters: ColumnFiltersState;
  setColumnFilters: (columnFilters: SetStateAction<ColumnFiltersState>) => void;
  availableChains?: ChainId[];
  withGlobalSearch: boolean;
  disabled?: boolean;
}
interface DashboardLiquidationActivityFiltersProps extends PropsWithChildren {
  filterProps: FilterProps;
}
const SEARCH_DEBOUNCE_TIME = 500;
const DashboardLiquidationActivityFilters = t0 => {
  const $ = _c(28);
  const {
    children,
    filterProps
  } = t0;
  const {
    filters,
    setColumnFilters,
    availableChains,
    withGlobalSearch,
    disabled: t1
  } = filterProps;
  const disabled = t1 === undefined ? false : t1;
  const isMobile = useIsMobile();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      chainIdsFilter: LIQUIDATION_COLUMN_IDS.Network,
      typeFilter: "Type",
      searchFilter: "global"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== setColumnFilters) {
    t3 = {
      setColumnFilters,
      filterMapping: t2
    };
    $[1] = setColumnFilters;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    handleFiltersChange
  } = useTableFiltersHandler(t3);
  let t4;
  if ($[3] !== filters) {
    t4 = filters.filter(_temp).flatMap(_temp2);
    $[3] = filters;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const chainIdsFilter = t4;
  const searchFilter = filters.find(_temp3)?.value as string;
  let t5;
  if ($[5] !== handleFiltersChange || $[6] !== searchFilter) {
    t5 = chainIdsFilter_0 => {
      handleFiltersChange({
        chainIdsFilter: chainIdsFilter_0,
        searchFilter,
        typeFilter: []
      });
    };
    $[5] = handleFiltersChange;
    $[6] = searchFilter;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleChainIdsFilterChange = t5;
  let t6;
  if ($[8] !== chainIdsFilter || $[9] !== handleFiltersChange) {
    t6 = value => {
      handleFiltersChange({
        chainIdsFilter,
        searchFilter: value.trim(),
        typeFilter: []
      });
    };
    $[8] = chainIdsFilter;
    $[9] = handleFiltersChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleSearchChange = t6;
  let t7;
  if ($[11] !== availableChains || $[12] !== chainIdsFilter || $[13] !== disabled || $[14] !== handleChainIdsFilterChange) {
    t7 = <AdvancedNetworkFilter disabled={disabled} chainIdsFilter={chainIdsFilter} handleChainIdsFilterChange={handleChainIdsFilterChange} availableChains={availableChains} page="dashboard_liquidation_activity" />;
    $[11] = availableChains;
    $[12] = chainIdsFilter;
    $[13] = disabled;
    $[14] = handleChainIdsFilterChange;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== disabled || $[17] !== handleSearchChange || $[18] !== isMobile || $[19] !== searchFilter || $[20] !== withGlobalSearch) {
    t8 = <Search placeholder="Search tx, market, or liquidator" width={200} fullWidth={isMobile} value={searchFilter} onChange={handleSearchChange} disabled={disabled} debounceTime={SEARCH_DEBOUNCE_TIME} isGlobalSearchInput={withGlobalSearch} />;
    $[16] = disabled;
    $[17] = handleSearchChange;
    $[18] = isMobile;
    $[19] = searchFilter;
    $[20] = withGlobalSearch;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <div className="gap-lg max-md:gap-sm flex flex-row items-center max-md:flex-wrap">{t7}{t8}</div>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== children || $[26] !== t9) {
    t10 = <div className="border-border bg-card p-md max-md:gap-sm box-content flex min-h-[26px] flex-row content-center justify-between rounded-none rounded-t-[20px] border-[0.5px] border-b-0 max-md:box-border max-md:flex-wrap">{children}{t9}</div>;
    $[25] = children;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export default DashboardLiquidationActivityFilters;
function _temp(filter) {
  return filter.id === LIQUIDATION_COLUMN_IDS.Network;
}
function _temp2(filter_0) {
  return filter_0.value as ChainId[];
}
function _temp3(filter_1) {
  return filter_1.id === "global";
}